(function () {
  'use strict';

  angular
    .module('service.gmap', [])

    /* @ngInject */
    .factory('GMaps', ["$window", "$q", "AppService", function ($window, $q, AppService) {
      var _this = this,
        getDefer = $q.defer(),
        getClustererDefer = $q.defer();
      this.get = function () {
        if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
          AppService.getParams()
            .then(function (params) {
              var url = 'https://maps.googleapis.com/maps/api/js?key=' + params.Localization.GMAPKey + '&libraries=geometry,places&callback=';
              $window.gMapsInit = function () {
                getDefer.resolve();
              };
              var script = document.createElement('script');
              script.src = url + 'gMapsInit';
              document.body.appendChild(script);
            })
            .catch(function (error) {
              console.error(error);
            });
        }
        return getDefer.promise;
      };
      this.getClusterer = function () {
        if (typeof MarkerClusterer === 'undefined') {
          $.ajax({
            url: '/js/markerclusterer.min.js',
            dataType: 'script',
            cache: true,
            success: function () {
              getClustererDefer.resolve();
            }
          });
        }
        return getClustererDefer.promise;
      };
      this.getGeoCode = function (address) {
        var defer = $q.defer();
        _this.get()
          .then(function () {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode( { 'address': address}, function (results, status) {
              if (status === 'OK') {
                var country = _.filter(results[0].address_components, function (item) {
                  return item.types[0] === 'country';
                });
                country = country[0].long_name;
                defer.resolve(
                  {
                    Latitude: results[0].geometry.location.lat(),
                    Longitude: results[0].geometry.location.lng(),
                    Country: country
                  }
                );
              } else {
                defer.reject({
                  status: status
                });
              }
            });
          })
          .catch(function (error) {
            return error;
          });
        return defer.promise;
      };
      this.getGeoCodeByGps = function (gps) {
        var defer = $q.defer();
        _this.get()
          .then(function () {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode( { 'location': {lat: gps.lat, lng: gps.lng}}, function (results, status) {
              if (status === 'OK') {
                var country = _.filter(results[0].address_components, function (item) {
                  return item.types[0] === 'country';
                });
                defer.resolve(
                  {
                    gps: {
                      Latitude: results[0].geometry.location.lat(),
                      Longitude: results[0].geometry.location.lng(),
                      Country: country[0].long_name,
                      CountryCode: country[0].short_name
                    },
                    address: results[0].formatted_address
                  }
                );
              } else {
                defer.reject('error');
              }
            });
          })
          .catch(function (error) {
            console.error(error);
          });
        return defer.promise;
      };
      return {
        get: this.get,
        getClusterer: this.getClusterer,
        getGeoCode: this.getGeoCode,
        getGeoCodeByGps: this.getGeoCodeByGps
      };
    }]);

})();
